import { KTCard, KTCardBody } from '../../../../_metronic/helpers';

const SaleOrderList: React.FC = () => {
  return (
    <>
      <div className='row justify-content-center mt-20'>
        <div className='col-xl-7 col-lg-7 col-md-12'>
          <KTCard>
            <KTCardBody className='py-4'>
              <div className='table-responsive'>
                <table
                  id='kt_table_location'
                  className='table align-middle table-row-dashed gy-5 dataTable no-footer'
                >
                  <thead>
                    <tr className='text-start text-muted fw-bolder text-uppercase gs-0'>
                      <th>Sales Order Number</th>
                      <th>Customer Name</th>
                      <th>Sales Order Date</th>
                      <th>Total Amount</th>
                      <th>Amount Recived</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600 fw-bold'>
                    <tr role='row'>
                      <td role='cell' className=''>
                        SO11
                      </td>
                      <td role='cell' className=''>
                        Raj Rao
                      </td>
                      <td role='cell' className=''>
                        19 Sep 2024
                      </td>
                      <td role='cell' className=''>
                        ₹9,000.00
                      </td>
                      <td role='cell' className=''>
                        ₹0.00
                      </td>
                      <td role='cell' className=''>
                        Created
                      </td>
                      <td role='cell' className='min-w-100px'>
                        <a
                          href='#'
                          className='btn btn-light btn-active-light-primary btn-sm'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions<i className='ki-solid ki-down fs-5 m-0'></i>
                        </a>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                          data-kt-menu='true'
                        >
                          <div className='menu-item px-3'>
                            <a className='menu-link px-3'>Detail</a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr role='row'>
                      <td role='cell' className=''>
                        SO11
                      </td>
                      <td role='cell' className=''>
                        Raj Rao
                      </td>
                      <td role='cell' className=''>
                        19 Sep 2024
                      </td>
                      <td role='cell' className=''>
                        ₹9,000.00
                      </td>
                      <td role='cell' className=''>
                        ₹0.00
                      </td>
                      <td role='cell' className=''>
                        Created
                      </td>
                      <td role='cell' className='min-w-100px'>
                        <a
                          href='#'
                          className='btn btn-light btn-active-light-primary btn-sm'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions<i className='ki-solid ki-down fs-5 m-0'></i>
                        </a>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                          data-kt-menu='true'
                        >
                          <div className='menu-item px-3'>
                            <a className='menu-link px-3'>Detail</a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr role='row'>
                      <td role='cell' className=''>
                        SO11
                      </td>
                      <td role='cell' className=''>
                        Raj Rao
                      </td>
                      <td role='cell' className=''>
                        19 Sep 2024
                      </td>
                      <td role='cell' className=''>
                        ₹9,000.00
                      </td>
                      <td role='cell' className=''>
                        ₹0.00
                      </td>
                      <td role='cell' className=''>
                        Created
                      </td>
                      <td role='cell' className='min-w-100px'>
                        <a
                          href='#'
                          className='btn btn-light btn-active-light-primary btn-sm'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions<i className='ki-solid ki-down fs-5 m-0'></i>
                        </a>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                          data-kt-menu='true'
                        >
                          <div className='menu-item px-3'>
                            <a className='menu-link px-3'>Detail</a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr role='row'>
                      <td role='cell' className=''>
                        SO11
                      </td>
                      <td role='cell' className=''>
                        Raj Rao
                      </td>
                      <td role='cell' className=''>
                        19 Sep 2024
                      </td>
                      <td role='cell' className=''>
                        ₹9,000.00
                      </td>
                      <td role='cell' className=''>
                        ₹0.00
                      </td>
                      <td role='cell' className=''>
                        Created
                      </td>
                      <td role='cell' className='min-w-100px'>
                        <a
                          href='#'
                          className='btn btn-light btn-active-light-primary btn-sm'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions<i className='ki-solid ki-down fs-5 m-0'></i>
                        </a>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                          data-kt-menu='true'
                        >
                          <div className='menu-item px-3'>
                            <a className='menu-link px-3'>Detail</a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr role='row'>
                      <td role='cell' className=''>
                        SO11
                      </td>
                      <td role='cell' className=''>
                        Raj Rao
                      </td>
                      <td role='cell' className=''>
                        19 Sep 2024
                      </td>
                      <td role='cell' className=''>
                        ₹9,000.00
                      </td>
                      <td role='cell' className=''>
                        ₹0.00
                      </td>
                      <td role='cell' className=''>
                        Created
                      </td>
                      <td role='cell' className='min-w-100px'>
                        <a
                          href='#'
                          className='btn btn-light btn-active-light-primary btn-sm'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions<i className='ki-solid ki-down fs-5 m-0'></i>
                        </a>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                          data-kt-menu='true'
                        >
                          <div className='menu-item px-3'>
                            <a className='menu-link px-3'>Detail</a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr role='row'>
                      <td role='cell' className=''>
                        SO11
                      </td>
                      <td role='cell' className=''>
                        Raj Rao
                      </td>
                      <td role='cell' className=''>
                        19 Sep 2024
                      </td>
                      <td role='cell' className=''>
                        ₹9,000.00
                      </td>
                      <td role='cell' className=''>
                        ₹0.00
                      </td>
                      <td role='cell' className=''>
                        Created
                      </td>
                      <td role='cell' className='min-w-100px'>
                        <a
                          href='#'
                          className='btn btn-light btn-active-light-primary btn-sm'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions<i className='ki-solid ki-down fs-5 m-0'></i>
                        </a>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                          data-kt-menu='true'
                        >
                          <div className='menu-item px-3'>
                            <a className='menu-link px-3'>Detail</a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </KTCardBody>
          </KTCard>
        </div>
      </div>
    </>
  );
};

export default SaleOrderList;
